import { PageLayout } from '../components/Layout/PageLayout';
import { AdvancedGame } from '../components/AdvancedGame/AdvancedGame';
import { AdvancedHero } from '../components/AdvancedGame/AdvancedHero';

export function AdvancedPage() {
  return (
    <PageLayout
      hero={<AdvancedHero />}
      game={<AdvancedGame />}
    />
  );
}